function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { RoutableSitecoreLink } from "../../../utils";
var Card = function Card(props) {
  var raised = props.raised,
    hover = props.hover,
    link = props.link,
    className = props.className,
    scaleAnimation = props.scaleAnimation,
    maxWidth = props.maxWidth,
    style = props.style;
  var children = props.children;
  var classes = function classes() {
    var usedClasses = 'card';
    if (raised) {
      usedClasses += ' card__raised';
    }
    if (hover) {
      usedClasses += ' card__hover';
    }
    if (link) {
      usedClasses += ' card__link';
    }
    if (scaleAnimation) {
      usedClasses += ' card__scale-anim';
    }
    if (className) {
      usedClasses += ' ' + className;
    }
    return usedClasses;
  };
  var newStyles = _objectSpread(_objectSpread({}, style), {}, {
    maxWidth: maxWidth ? "".concat(maxWidth, "px") : undefined
  });
  if (link) {
    return /*#__PURE__*/React.createElement(RoutableSitecoreLink, {
      className: classes(),
      field: link,
      style: newStyles ? newStyles : undefined
    }, /*#__PURE__*/React.createElement(React.Fragment, null, children));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes(),
    style: newStyles ? newStyles : undefined
  }, children);
};
export default Card;